import React, { useEffect, useState } from 'react';
import logo from 'assets/img/dohwa.png';

export default function Invoice(props) {
  const { isTextField, invoiceInfo } = props;

  const trHeight = { height: '22px' };
  const tdTotalLeftStyle = { width: '600px', textAlign: 'right', fontWeight: 'bold' };
  const tdTotalRightStyle = { width: '200px', textAlign: 'right' };

  return (
    <div id="page" className="page a4">
      <div style={{ position: 'relative', marginTop: '30px' }}>
        <img src={logo} width="200px" style={{ position: 'absolute' }} />
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td style={{ width: '100%', textAlign: 'right' }}>
                <strong>제공 : (주)도화엔지니어링</strong>
              </td>
            </tr>
            <tr>
              <td style={{ width: '100%', textAlign: 'right' }}>서울시 강남구 삼성로 438(대치동)</td>
            </tr>
          </tbody>
        </table>
      </div>
      <table style={{ float: 'left', fontWeight: 'bold', width: '100%', marginTop: '60px', marginBottom: '30px' }}>
        <tbody>
          <tr>
            <td style={{ width: '100%', textAlign: 'center' }}>
              <h1>
                Invoice <CustomInput isTextField={isTextField} id="orderNo" value={invoiceInfo?.orderNo} label="ORDER_NO" />
              </h1>
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: '100%', height: '110px' }}>
        <tbody>
          <tr style={trHeight}>
            <td style={{ width: '70%', height: '22px' }}>
              <strong>상세 사항</strong>
            </td>
            <td style={{ width: '30%', height: '22px', textAlign: 'left' }}>
              <strong>수취인</strong>
            </td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}>
              주문번호 :
              <CustomInput isTextField={isTextField} id="orderNo" value={invoiceInfo?.orderNo} label="ORDER_NO" />
            </td>
            <td style={{ width: '30%', textAlign: 'left' }}>
              <CustomInput isTextField={isTextField} id="companyName" value={invoiceInfo?.companyName} label="COMPANY_NAME" />
            </td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}>
              주문일 :
              <CustomInput isTextField={isTextField} id="orderDate" value={invoiceInfo?.orderDate} label="ORDER_DATE" />
            </td>
            <td style={{ width: '30%', textAlign: 'left' }}>
              <CustomInput isTextField={isTextField} id="companyNo" value={invoiceInfo?.companyNo} label="COMPANY_NO" />
            </td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}></td>
            <td style={{ width: '30%', textAlign: 'left' }}>
              <CustomInput isTextField={isTextField} id="userid" value={invoiceInfo?.userid} label="USER_ID" style={{ width: '70px' }} />
              ( <CustomInput isTextField={isTextField} id="username" value={invoiceInfo?.username} label="USER_NAME" style={{ width: '70px' }} /> )
            </td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}></td>
            <td style={{ width: '30%', textAlign: 'left' }}>
              <CustomInput isTextField={isTextField} id="cellPhoneNumber" value={invoiceInfo?.cellPhoneNumber} label="CELL_PHONE_NUMBER" />
            </td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}></td>
            <td style={{ width: '30%', textAlign: 'left' }}>
              <CustomInput isTextField={isTextField} id="eMail" value={invoiceInfo?.eMail} label="E_MAIL" />
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: '100%', marginTop: '70px', border: 'solid 1px gray' }}>
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '30%' }} />
          <col style={{ width: '40%' }} />
        </colgroup>
        <tbody>
          <tr style={{ backgroundColor: 'gray', color: 'white' }}>
            <th>품명</th>
            <th>수량</th>
            <th>금액</th>
          </tr>
          <tr>
            <td style={{ textAlign: 'center' }}>사용권</td>
            <td style={{ textAlign: 'right' }}>
              <CustomInput isTextField={isTextField} id="quantity" value={invoiceInfo?.quantity} label="QUANTITY" unit="장" style={{ width: '80%' }} />
            </td>
            <td style={{ textAlign: 'right' }}>
              <CustomInput isTextField={isTextField} id="totalAmount" value={invoiceInfo?.totalAmount} label="TOTAL_AMOUNT" unit="원" style={{ width: '80%' }} />
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        * 입금계좌: 하나은행 257-910051-17304 ㈜도화엔지니어링
        <br />* 입금자는 회사명으로 해주시기 바랍니다.
      </p>
      <table style={{ width: '100%', marginTop: '70px' }}>
        <tbody>
          {/*<tr>*/}
          {/*  <td style={tdTotalLeftStyle}>사용권 금액 :</td>*/}
          {/*  <td style={tdTotalRightStyle}>*/}
          {/*    <CustomInput isTextField={isTextField} id="totalAmount" value={invoiceInfo?.totalAmount} label="TOTAL_AMOUNT" unit="원" style={{ width: '80%' }} />*/}
          {/*  </td>*/}
          {/*</tr>*/}
          {/*<tr>*/}
          {/*  <td style={tdTotalLeftStyle}>할인 금액 :</td>*/}
          {/*  <td style={tdTotalRightStyle}>*/}
          {/*    {isTextField ? (*/}
          {/*      <CustomInput isTextField={isTextField} id="discountAmount" value={invoiceInfo?.discountAmount} label="DISCOUNT_AMOUNT" unit="원" style={{ width: '80%' }} />*/}
          {/*    ) : !isNaN(invoiceInfo?.discountAmount) || invoiceInfo?.discountAmount ? (*/}
          {/*      `${invoiceInfo?.discountAmount} 원`*/}
          {/*    ) : (*/}
          {/*      'DISCOUNT_AMOUNT 원'*/}
          {/*    )}*/}
          {/*  </td>*/}
          {/*</tr>*/}
          <tr>
            <td style={tdTotalLeftStyle}>공급가액 :</td>
            <td style={tdTotalRightStyle}>
              <CustomInput isTextField={isTextField} id="sumAmount" value={invoiceInfo?.sumAmount} label="SUM_AMOUNT" unit="원" style={{ width: '80%' }} />
            </td>
          </tr>
          <tr>
            <td style={tdTotalLeftStyle}>부가세 :</td>
            <td style={tdTotalRightStyle}>
              <CustomInput isTextField={isTextField} id="vatAmount" value={invoiceInfo?.vatAmount} label="VAT_AMOUNT" unit="원" style={{ width: '80%' }} />
            </td>
          </tr>
          <tr>
            <td style={tdTotalLeftStyle}>최종 결제 금액 :</td>
            <td style={tdTotalRightStyle}>
              <CustomInput isTextField={isTextField} id="depositAmount" value={invoiceInfo?.depositAmount} label="DEPOSIT_AMOUNT" unit="원" style={{ width: '80%' }} />
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
      <br />
      <p style={{ fontSize: 'smaller' }}>
        구매해 주셔서 감사합니다.
        <br />
        구매한 제품 및 서비스는 기간에 공표되고 합의된 이용 약관에 따라 제공됩니다.
        <br />
        구매 및 영수증에 대한 질문은 swmaster@dohwa.co.kr으로 보내주시면 답변드리겠습니다.
      </p>
    </div>
  );
}

const CustomInput = (props) => {
  const { isTextField, id, value, label, unit, style } = props;
  const [newValue, setNewValue] = useState(null);

  useEffect(() => {
    setNewValue(value);
  }, [value]);

  return (
    <>
      {isTextField ? <input id={id} value={newValue} onChange={(e) => setNewValue(e.target.value)} placeholder={label} style={{ ...style }} /> : newValue || label} {unit || ''}
    </>
  );
};
